import { useEffect } from 'react'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import ProcessosInscritos from '../../components/ProcessosInscritos'

function ProcessosInscritosPage() {

    useEffect(() => {

        document.title = 'Minhas Candidaturas'

    }, [])

    return (
        <div>
            <Header />
            <ProcessosInscritos />
            <Footer />
        </div>
    )
}

export default ProcessosInscritosPage